<div class="{{ baseClasses() }} {{ variantClasses() }} {{ sizeClass() }}"></div>
